/// <reference path="../../../types/icons.d.ts"/>
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import BookRoundedIcon from '@mui/icons-material/BookRounded';
import ChromeReaderModeRoundedIcon from '@mui/icons-material/ChromeReaderModeRounded';
import WebRoundedIcon from '@mui/icons-material/WebRounded';

const standardNavIcons = {
  ReaderIcon: ChromeReaderModeRoundedIcon,
  BookIcon: BookRoundedIcon,
  DescriptionIcon: ArticleRoundedIcon,
  VisibilityIcon: VisibilityRoundedIcon,
  WebIcon: WebRoundedIcon,
};

export default standardNavIcons;
